import { render, staticRenderFns } from "./set-time-limits-dialog.vue?vue&type=template&id=61e91bb4"
import script from "./set-time-limits-dialog.vue?vue&type=script&lang=js"
export * from "./set-time-limits-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports